<template>
  <div>
    <!-- Modal em destaque (primeira vez) -->
    <b-modal
      v-model="showFullModal"
      centered
      size="lg"
      hide-header
      hide-footer
      modal-class="welcome-modal-2026"
      body-class="modal-body-custom"
      @shown="startFireworks"
      @hidden="handleModalClose"
    >
      <div class="text-center modal-padding modal-scroll-container">
        <!-- Canvas para fogos de artifício -->
        <canvas
          ref="fireworksCanvas"
          class="fireworks-container"
        />

        <!-- Conteúdo -->
        <div class="welcome-content">
          <h1 class="welcome-title font-weight-bold text-primary title-spacing">
            🎉 Feliz 2026! 🎉
          </h1>

          <h3 class="welcome-subtitle subtitle-spacing">
            Bem-vindo(a) à ManyConvert!
          </h3>

          <div class="text-center content-spacing px-3">
            <p class="welcome-intro mb-3">
              Estamos muito felizes em começar este novo ano com você! 🚀
            </p>

            <div class="features-list">
              <div class="feature-item">
                <span class="feature-icon">✨</span>
                <span class="feature-text">Central de Atendimento renovada e mais intuitiva</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🤖</span>
                <span class="feature-text">IA mais otimizada para atendimento</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">📊</span>
                <span class="feature-text">Dashboards aprimorados com mais insights</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">💰</span>
                <span class="feature-text">Venda mais com as nossas campanhas</span>
              </div>
            </div>
          </div>

          <p class="welcome-message message-spacing">
            Que este ano seja repleto de sucesso e realizações para você e sua empresa! 🌟
            <br class="d-none d-md-inline">
            <span class="d-md-none" />
            Bora converter! 🚀
          </p>

          <div class="button-spacing">
            <b-button
              variant="primary"
              size="lg"
              pill
              class="welcome-button px-5"
              @click="closeFullModal"
            >
              Começar a usar! 🎯
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Mini widget no canto inferior direito -->
    <transition name="slide-up">
      <div
        v-if="showMiniWidget"
        class="mini-welcome-widget"
        @click="openFullModal"
      >
        <div class="mini-widget-content">
          <div class="mini-widget-icon">
            🎉
          </div>
          <div class="mini-widget-text">
            <strong>Feliz 2026!</strong>
            <small>Clique para ver as novidades</small>
          </div>
        </div>
        <button
          class="mini-widget-close"
          @click.stop="closeMiniWidget"
        >
          ×
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'WelcomeModal2026',
  components: {
    BModal,
    BButton,
  },
  data() {
    return {
      showFullModal: false,
      showMiniWidget: false,
      fireworksAnimation: null,
      particles: [],
      backdropClickHandler: null,
    }
  },
  mounted() {
    this.checkWelcomeStatus()
  },
  beforeDestroy() {
    this.stopFireworks()
  },
  methods: {
    checkWelcomeStatus() {
      const hasSeenWelcome = localStorage.getItem('welcome_2026_seen')

      if (!hasSeenWelcome) {
        // Primeira vez - mostra o modal completo após um pequeno delay
        setTimeout(() => {
          this.showFullModal = true
        }, 500)
      } else {
        // Já viu - mostra o mini widget
        const hasClosedWidget = localStorage.getItem('welcome_2026_widget_closed')
        if (!hasClosedWidget) {
          setTimeout(() => {
            this.showMiniWidget = true
          }, 1000)
        }
      }
    },
    startFireworks() {
      // Adiciona listener para fechar ao clicar no backdrop
      this.$nextTick(() => {
        const backdrop = document.querySelector('.modal-backdrop')
        if (backdrop) {
          // Armazena a referência da função para poder removê-la depois
          this.backdropClickHandler = e => {
            if (e.target.classList.contains('modal-backdrop')) {
              this.showFullModal = false
            }
          }
          backdrop.addEventListener('click', this.backdropClickHandler)
        }
      })

      const canvas = this.$refs.fireworksCanvas
      if (!canvas) return

      const ctx = canvas.getContext('2d')
      const parent = canvas.parentElement
      canvas.width = parent.offsetWidth
      canvas.height = parent.offsetHeight

      // Cores vibrantes para os fogos
      const colors = [
        '#ff0844', '#ffb199', '#75d8ff', '#ffd800', '#b967ff',
        '#05ffa1', '#fffb96', '#ff6c00', '#ff006e', '#8338ec',
      ]

      // Classe Particle
      class Particle {
        constructor(x, y, color, velocity, gravity = 0.08) {
          this.x = x
          this.y = y
          this.color = color
          this.velocity = velocity
          this.life = 1.0
          this.decay = Math.random() * 0.015 + 0.005
          this.gravity = gravity
          this.size = Math.random() * 2 + 1
        }

        update() {
          this.velocity.x *= 0.99
          this.velocity.y *= 0.99
          this.velocity.y += this.gravity
          this.x += this.velocity.x
          this.y += this.velocity.y
          this.life -= this.decay
        }

        draw(ctx) {
          ctx.save()
          ctx.globalAlpha = this.life
          ctx.fillStyle = this.color
          ctx.beginPath()
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2)
          ctx.fill()

          // Brilho adicional
          ctx.globalAlpha = this.life * 0.5
          ctx.beginPath()
          ctx.arc(this.x, this.y, this.size * 2, 0, Math.PI * 2)
          ctx.fill()
          ctx.restore()
        }
      }

      // Criar explosão de fogos
      const createFirework = (x, y) => {
        const color = colors[Math.floor(Math.random() * colors.length)]
        const particleCount = Math.random() * 30 + 50

        for (let i = 0; i < particleCount; i++) {
          const angle = (Math.PI * 2 / particleCount) * i
          const speed = Math.random() * 3 + 2
          const velocity = {
            x: Math.cos(angle) * speed,
            y: Math.sin(angle) * speed,
          }
          this.particles.push(new Particle(x, y, color, velocity))
        }
      }

      // Loop de animação
      const animate = () => {
        ctx.fillStyle = 'rgba(255, 255, 255, 0.1)'
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        // Atualizar e desenhar partículas
        this.particles = this.particles.filter(particle => {
          particle.update()
          particle.draw(ctx)
          return particle.life > 0
        })

        // Criar novos fogos aleatoriamente
        if (Math.random() < 0.05) {
          const x = Math.random() * canvas.width
          const y = Math.random() * canvas.height * 0.6 + canvas.height * 0.2
          createFirework(x, y)
        }

        this.fireworksAnimation = requestAnimationFrame(animate)
      }

      // Limpar canvas e iniciar
      ctx.fillStyle = 'transparent'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // Criar alguns fogos iniciais
      for (let i = 0; i < 3; i++) {
        setTimeout(() => {
          const x = Math.random() * canvas.width
          const y = Math.random() * canvas.height * 0.6 + canvas.height * 0.2
          createFirework(x, y)
        }, i * 300)
      }

      animate()
    },
    stopFireworks() {
      if (this.fireworksAnimation) {
        cancelAnimationFrame(this.fireworksAnimation)
        this.fireworksAnimation = null
      }
      this.particles = []
    },
    closeFullModal() {
      // Apenas fecha o modal, o evento @hidden vai chamar handleModalClose
      this.showFullModal = false
    },
    handleModalClose() {
      // Remove o listener do backdrop
      const backdrop = document.querySelector('.modal-backdrop')
      if (backdrop && this.backdropClickHandler) {
        backdrop.removeEventListener('click', this.backdropClickHandler)
        this.backdropClickHandler = null
      }

      // Para os fogos de artifício quando o modal fecha
      this.stopFireworks()

      // Salva que o modal foi visto
      localStorage.setItem('welcome_2026_seen', 'true')

      // Mostra o mini widget após fechar o modal
      setTimeout(() => {
        this.showMiniWidget = true
      }, 500)
    },
    openFullModal() {
      this.showMiniWidget = false
      this.showFullModal = true
    },
    closeMiniWidget() {
      this.showMiniWidget = false
      localStorage.setItem('welcome_2026_widget_closed', 'true')
    },
  },
}
</script>

<style scoped>
/* Modal em destaque */
.modal-padding {
  padding: 2rem;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-scroll-container {
  position: relative;
}

.welcome-content {
  position: relative;
  z-index: 2;
}

/* Espaçamentos adaptativos */
.title-spacing {
  margin-bottom: 1rem;
}

.subtitle-spacing {
  margin-bottom: 1.5rem;
}

.content-spacing {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.message-spacing {
  margin-top: 1.5rem;
}

.button-spacing {
  margin-top: 1.5rem;
}

/* Títulos responsivos */
.welcome-title {
  font-size: 3rem;
  line-height: 1.2;
}

.welcome-subtitle {
  font-size: 1.75rem;
  line-height: 1.3;
}

.welcome-intro {
  font-size: 1.25rem;
  line-height: 1.4;
}

.welcome-message {
  font-size: 1.25rem;
  line-height: 1.5;
}

.welcome-button {
  font-size: 1.1rem;
}

/* Container de fogos de artifício com tsparticles */
.fireworks-container {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1 !important;
  pointer-events: none !important;
}

#fireworks-particles {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.features-list {
  background-color: rgba(248, 249, 250, 0.95);
  border-radius: 12px;
  padding: 1.5rem;
  margin: 1rem 0;
}

.feature-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
  font-size: 1.1rem;
  text-align: left;
}

.feature-item:not(:last-child) {
  border-bottom: 1px solid #e9ecef;
}

.feature-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  min-width: 40px;
  text-align: center;
  flex-shrink: 0;
}

.feature-text {
  flex: 1;
}

/* Mini widget no canto inferior direito */
.mini-welcome-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 280px;
  background: linear-gradient(135deg, #9A3092 0%, #772270 100%);
  color: white;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
  overflow: hidden;
}

.mini-welcome-widget:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.mini-widget-content {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.mini-widget-icon {
  font-size: 2.5rem;
  margin-right: 1rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.mini-widget-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.mini-widget-text strong {
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.mini-widget-text small {
  font-size: 0.85rem;
  opacity: 0.9;
}

.mini-widget-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1;
  padding: 0;
}

.mini-widget-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* Animação de entrada do mini widget */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100px);
  opacity: 0;
}

/* Responsivo para tablets */
@media (max-width: 992px) {
  .modal-padding {
    padding: 1.75rem 1.5rem;
    max-height: 85vh;
  }

  .title-spacing {
    margin-bottom: 0.875rem;
  }

  .subtitle-spacing {
    margin-bottom: 1.25rem;
  }

  .content-spacing {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .message-spacing {
    margin-top: 1.25rem;
  }

  .button-spacing {
    margin-top: 1.25rem;
  }

  .welcome-title {
    font-size: 2.5rem;
  }

  .welcome-subtitle {
    font-size: 1.5rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 1.1rem;
  }

  .features-list {
    padding: 1.25rem;
  }

  .feature-item {
    font-size: 1rem;
    padding: 0.65rem 0;
  }

  .feature-icon {
    font-size: 1.35rem;
    min-width: 35px;
  }
}

/* Responsivo para mobile */
@media (max-width: 768px) {
  .modal-padding {
    padding: 1.5rem 1rem;
    max-height: 80vh;
  }

  .title-spacing {
    margin-bottom: 0.75rem;
  }

  .subtitle-spacing {
    margin-bottom: 1rem;
  }

  .content-spacing {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .message-spacing {
    margin-top: 1rem;
  }

  .button-spacing {
    margin-top: 1rem;
  }

  .welcome-title {
    font-size: 2rem;
  }

  .welcome-subtitle {
    font-size: 1.25rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 1rem;
  }

  .welcome-button {
    font-size: 1rem;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .features-list {
    padding: 1rem;
    margin: 0.75rem 0;
  }

  .feature-item {
    font-size: 0.95rem;
    padding: 0.6rem 0;
  }

  .feature-icon {
    font-size: 1.25rem;
    min-width: 32px;
    margin-right: 0.75rem;
  }

  .mini-welcome-widget {
    width: 260px;
    bottom: 15px;
    right: 15px;
  }

  .fireworks-container {
    font-size: 2rem;
  }
}

/* Responsivo para mobile pequeno */
@media (max-width: 576px) {
  .modal-padding {
    padding: 1.25rem 0.75rem;
    max-height: 85vh;
  }

  .title-spacing {
    margin-bottom: 0.625rem;
  }

  .subtitle-spacing {
    margin-bottom: 0.875rem;
  }

  .content-spacing {
    margin-top: 0.875rem;
    margin-bottom: 0.875rem;
  }

  .message-spacing {
    margin-top: 0.875rem;
  }

  .button-spacing {
    margin-top: 0.875rem;
  }

  .welcome-title {
    font-size: 1.75rem;
  }

  .welcome-subtitle {
    font-size: 1.1rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 0.95rem;
  }

  .welcome-button {
    font-size: 0.95rem;
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .features-list {
    padding: 0.875rem;
  }

  .feature-item {
    font-size: 0.9rem;
    padding: 0.5rem 0;
  }

  .feature-icon {
    font-size: 1.15rem;
    min-width: 28px;
    margin-right: 0.65rem;
  }

  .mini-welcome-widget {
    width: calc(100vw - 30px);
    max-width: 260px;
    bottom: 10px;
    right: 10px;
  }

  .mini-widget-icon {
    font-size: 2rem;
    margin-right: 0.75rem;
  }

  .mini-widget-text strong {
    font-size: 1rem;
  }

  .mini-widget-text small {
    font-size: 0.8rem;
  }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 400px) {
  .modal-padding {
    padding: 1rem 0.5rem;
    max-height: 88vh;
  }

  .title-spacing {
    margin-bottom: 0.5rem;
  }

  .subtitle-spacing {
    margin-bottom: 0.75rem;
  }

  .content-spacing {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .message-spacing {
    margin-top: 0.75rem;
  }

  .button-spacing {
    margin-top: 0.75rem;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-subtitle {
    font-size: 1rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 0.875rem;
  }

  .welcome-button {
    font-size: 0.875rem;
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .features-list {
    padding: 0.75rem;
  }

  .feature-item {
    font-size: 0.85rem;
    padding: 0.45rem 0;
  }

  .feature-icon {
    font-size: 1rem;
    min-width: 26px;
    margin-right: 0.5rem;
  }

  .mini-welcome-widget {
    width: calc(100vw - 20px);
    max-width: 240px;
  }

  .mini-widget-content {
    padding: 0.875rem;
  }
}

/* Responsividade por altura da tela */
/* Para telas com altura pequena (landscape mobile, tablets horizontais) */
@media (max-height: 700px) {
  .modal-padding {
    padding: 1rem;
    max-height: 95vh;
  }

  .title-spacing {
    margin-bottom: 0.5rem;
  }

  .subtitle-spacing {
    margin-bottom: 0.75rem;
  }

  .content-spacing {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .message-spacing {
    margin-top: 0.75rem;
  }

  .button-spacing {
    margin-top: 0.75rem;
  }

  .welcome-title {
    font-size: 2rem;
  }

  .welcome-subtitle {
    font-size: 1.25rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 0.95rem;
  }

  .features-list {
    padding: 0.875rem;
    margin: 0.5rem 0;
  }

  .feature-item {
    padding: 0.5rem 0;
    font-size: 0.9rem;
  }

  .feature-icon {
    font-size: 1.15rem;
  }
}

/* Para telas muito baixas (landscape em celulares pequenos) */
@media (max-height: 550px) {
  .modal-padding {
    padding: 0.75rem 1rem;
    max-height: 98vh;
  }

  .title-spacing {
    margin-bottom: 0.375rem;
  }

  .subtitle-spacing {
    margin-bottom: 0.5rem;
  }

  .content-spacing {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .message-spacing {
    margin-top: 0.5rem;
  }

  .button-spacing {
    margin-top: 0.5rem;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-subtitle {
    font-size: 1.1rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 0.875rem;
  }

  .welcome-button {
    font-size: 0.875rem;
    padding: 0.5rem 1.25rem !important;
  }

  .features-list {
    padding: 0.625rem;
    margin: 0.375rem 0;
  }

  .feature-item {
    padding: 0.375rem 0;
    font-size: 0.85rem;
  }

  .feature-icon {
    font-size: 1rem;
    min-width: 26px;
  }
}

/* Combinação de tela pequena em largura E altura */
@media (max-width: 576px) and (max-height: 700px) {
  .modal-padding {
    padding: 0.875rem 0.75rem;
    max-height: 95vh;
  }

  .welcome-title {
    font-size: 1.65rem;
  }

  .welcome-subtitle {
    font-size: 1.05rem;
  }
}

@media (max-width: 400px) and (max-height: 650px) {
  .modal-padding {
    padding: 0.75rem 0.5rem;
    max-height: 96vh;
  }

  .welcome-title {
    font-size: 1.4rem;
  }

  .welcome-subtitle {
    font-size: 0.95rem;
  }

  .welcome-intro,
  .welcome-message {
    font-size: 0.8rem;
  }
}
</style>

<style>
/* Estilos globais para o modal */
.welcome-modal-2026 .modal-dialog {
  max-height: 95vh;
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
}

.welcome-modal-2026 .modal-content {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  max-height: 95vh;
}

.welcome-modal-2026 .modal-body {
  padding: 0;
  max-height: 95vh;
  overflow: hidden;
}

.modal-body-custom {
  overflow: hidden;
}

/* Customização da scrollbar */
.modal-padding::-webkit-scrollbar {
  width: 8px;
}

.modal-padding::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.modal-padding::-webkit-scrollbar-thumb {
  background: rgba(154, 48, 146, 0.3);
  border-radius: 10px;
}

.modal-padding::-webkit-scrollbar-thumb:hover {
  background: rgba(154, 48, 146, 0.5);
}

/* Responsivo */
@media (max-width: 768px) {
  .welcome-modal-2026 .modal-dialog {
    max-height: 92vh;
    margin: 1rem auto;
  }

  .welcome-modal-2026 .modal-content {
    max-height: 92vh;
  }

  .welcome-modal-2026 .modal-body {
    max-height: 92vh;
  }

  .mini-welcome-widget {
    width: 260px;
    bottom: 15px;
    right: 15px;
  }

  .fireworks-container {
    font-size: 2rem;
  }
}

@media (max-height: 700px) {
  .welcome-modal-2026 .modal-dialog {
    max-height: 98vh;
    margin: 0.5rem auto;
  }

  .welcome-modal-2026 .modal-content {
    max-height: 98vh;
  }

  .welcome-modal-2026 .modal-body {
    max-height: 98vh;
  }
}

@media (max-height: 550px) {
  .welcome-modal-2026 .modal-dialog {
    max-height: 99vh;
    margin: 0.25rem auto;
  }

  .welcome-modal-2026 .modal-content {
    max-height: 99vh;
  }

  .welcome-modal-2026 .modal-body {
    max-height: 99vh;
  }
}
</style>
